import { render, staticRenderFns } from "./uploadImmaginiModal.vue?vue&type=template&id=31778ac3&scoped=true&"
import script from "./uploadImmaginiModal.vue?vue&type=script&lang=ts&"
export * from "./uploadImmaginiModal.vue?vue&type=script&lang=ts&"
import style0 from "./uploadImmaginiModal.vue?vue&type=style&index=0&id=31778ac3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31778ac3",
  null
  
)

export default component.exports